import {Button, ButtonStyle} from '@mintdata-wsp/common/components/button/Button';
import {MDIcon, MDIconSize} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {MDIntent} from '@mintdata-wsp/common/components/MDIntent';
import {DesignVersion, DesignVersionId} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignVersionsState';
import {Dialogs} from '@mintdata-wsp/wsp/controllers/common/DialogsController';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Scrollable, ScrollBehavior} from '@mintdata-wsp/wsp/ui/components/scrollable/Scrollable';
import {ConfirmButtonSet} from '@mintdata-wsp/wsp/ui/dialogs/ConfirmDialog';
import {DeleteDialog} from '@mintdata-wsp/wsp/ui/dialogs/DeleteDialog';
import {DateTimeUtil} from '@mintdata-wsp/wsp/util/DateTimeUtil';
import {
    ContextMenu,
    ContextMenuTarget,
    IContextMenuItem,
    PopupAnchor,
    SourceAnchor,
    ToggleOn
} from '@mintdata/mint-kit/impl/components/contextMenu/ContextMenu';
import {Window} from '@mintdata/mint-kit/impl/components/popover/Window';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {action} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./VersionsPanel.less');
const cx = classnames.bind(styles);

@observer
export class VersionsPanel extends React.Component<any, any>
{
    componentDidMount():void
    {
        controllers.ui.designVersions.refresh();
    }

    public render():JSX.Element
    {
        return (
            <div className={cx('base')}>
                {this._renderHeader()}
                {/*{this._renderActions()}*/}
                {this._renderVersions()}
                {this._renderRestoreMessage()}
            </div>
        );
    }

    private _renderHeader():JSX.Element
    {
        return (
            <div className={cx('topHeader')}>
                <div className={cx('title')}>
                    Version history
                </div>
                <Button
                    className={cx('close')}
                    style={ButtonStyle.SimpleSecondary}
                    icon={MDIcons.common.Close}
                    iconSize={MDIconSize.medium}
                    onClick={this._onClickClosePanel}
                />
            </div>
        );
    }

    private _onClickClosePanel(event:React.MouseEvent<HTMLElement>):void
    {
        event.preventDefault();
        event.stopPropagation();

        controllers.ui.designVersions.showPanel(false);
    }

    private _renderActions():JSX.Element
    {
        const dvc = controllers.ui.designVersions;
        const versionsState = dvc.getState();
        const {selectedVersions} = versionsState;

        const isDiffVisible = dvc.isDiffVisible();
        const isDetailsVisible = dvc.isDetailsVisible();

        let title = '';
        let isDisabled = false;

        if( isDiffVisible )
        {
            title = 'Hide diff';
        }
        else if( isDetailsVisible )
        {
            title = 'Hide details';
        }
        else
        {
            if( selectedVersions.length === 0 )
            {
                isDisabled = true;
                title = 'Select to compare';
            }
            else if( selectedVersions.length === 1 )
            {
                title = 'View details';
            }
            else if( selectedVersions.length === 2 )
            {
                title = 'Compare';
            }
        }

        return (
            <div className={cx('actions')}>
                <button
                    className={cx('btn', 'btnCompare', {isDisabled})}
                    onClick={this._onClickActionBtn}
                >
                    {title}
                </button>
            </div>
        );
    }

    private _onClickActionBtn(event:React.MouseEvent<HTMLElement>):void
    {
        event.preventDefault();
        event.stopPropagation();

        const dvc = controllers.ui.designVersions;

        const isDiffVisible = dvc.isDiffVisible();
        const isDetailsVisible = dvc.isDetailsVisible();

        if( isDiffVisible )
        {
            dvc.showDiff(false);
        }
        else if( isDetailsVisible )
        {
            dvc.showDetails(false);
        }
        else
        {
            const versionsState = dvc.getState();
            const {length} = versionsState.selectedVersions;

            if( length === 0 ) return;
            if( length === 1 ) dvc.showDetails();
            if( length === 2 ) dvc.showDiff();
        }
    }

    private _onClickNameVersionButton(event:React.MouseEvent<HTMLElement>):void
    {
        event.preventDefault();
        event.stopPropagation();

        controllers.ui.dialogs.showDialog(Dialogs.NameCurrentVersion, false);
    }

    private _renderVersions():JSX.Element
    {
        const currentVersion = controllers.ui.designVersions.getCurrentVersion();
        const versions = controllers.ui.designVersions.getVersions();

        return (
            <Scrollable
                isScrollX={false}
                isScrollY={true}
                behavior={ScrollBehavior.OnHover}
                containerClassName={cx('versions')}
                className={cx('versionsInner')}
            >
                {this._renderVersion(currentVersion)}
                {versions.map(this._renderVersion)}
            </Scrollable>
        );
    }

    @bind
    private _renderVersion(version:DesignVersion):JSX.Element
    {
        if( !version ) return;

        const dvc = controllers.ui.designVersions;

        const isOpened = dvc.isOpened(version.id);
        const isSelected = dvc.isSelected(version.id);

        return (
            <div
                key={version.id}
                className={cx('version', {isOpened})}
                onClick={(e) => this._onClickVersion(e, version.id)}
            >
                <div className={cx('header')}>

                    {/*<div className={cx('checkbox')}>*/}
                    {/*<Checkbox*/}
                    {/*isChecked={isSelected}*/}
                    {/*disabled={true}*/}
                    {/*onClick={(e) => this._onClickVersionCheckbox(e, version.id)}*/}
                    {/*/>*/}
                    {/*</div>*/}

                    <div className={cx('name')}>
                        {this._renderName(version)}
                    </div>

                    <div className={cx('icons')}>
                        {
                            version.isPublished &&
                            <svg
                                className={cx('icon', 'isPublished')}
                                width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M16.125 8.367A6.242 6.242 0 0 0 10 3.333 6.246 6.246 0 0 0 4.458 6.7 4.995 4.995 0 0 0 0 11.667c0 2.758 2.242 5 5 5h10.833c2.3 0 4.167-1.867 4.167-4.167 0-2.2-1.708-3.983-3.875-4.133zm-4.458 2.466v3.334H8.333v-3.334h-2.5L10 6.667l4.167 4.166h-2.5z" />
                            </svg>
                        }
                    </div>

                    {!version.isCurrent && this._renderMenu(version.id)}

                </div>

                <div className={cx('body')}>

                    <div className={cx('timestamp')}>
                        {DateTimeUtil.toFormatString(version.timestamp, 'MMM DD, hh:mm')}
                    </div>

                    <div className={cx('author')}>
                        {version.author}
                    </div>

                    {
                        version.description &&
                        <div className={cx('description')}>
                            {version.description}
                        </div>
                    }
                </div>

                {version.isCurrent && <div className={cx('nameVersionButton')}>
                    <button
                        className={cx('btn', 'btnCompare')}
                        onClick={this._onClickNameVersionButton}
                    >
                        Name Current Version
                    </button>
                </div>}

            </div>
        );
    }

    private _renderName(version:DesignVersion)
    {
        return (
            <span>
                {version.isCurrent && <span dangerouslySetInnerHTML={{__html: '&lt; '}} />}
                {version.name}
                {version.isCurrent && <span dangerouslySetInnerHTML={{__html: ' &gt;'}} />}
            </span>
        );
    }

    private _renderRestoreMessage():JSX.Element
    {
        const {ui: {designVersions}} = controllers;
        const state = designVersions.getState();

        return state.restoreVersion
            ? (
                <Window
                    id='DeleteDialog'
                    onDismissed={this._onDiscardRestore}
                    hasModalBackground={true}
                >
                    <DeleteDialog
                        title="Restore design version"
                        message={state.isRestoring ?
                            <div>
                                <span>Restoring version </span><b>{state.restoreVersion.name}</b>
                            </div>
                            :
                            <div>
                                <div>Current design will be replaced by the</div>
                                <div><b>{state.restoreVersion.name}</b><span> version.</span></div>
                            </div>
                        }
                        actionText={state.isRestoring ? 'Please wait...' : 'Restore version'}
                        
                        isDisabled={state.isRestoring}
                        onClose={this._onDiscardRestore}
                        onClickDelete={this._onConfirmRestore}
                    />
                </Window>
            ) : null;
    }

    private _onDiscardRestore():void
    {
        controllers.ui.designVersions.discardRestoreVersion();
    }

    private _onConfirmRestore():void
    {
        controllers.ui.designVersions.restoreVersion();
    }

    private _onClickVersionCheckbox(event:React.MouseEvent<HTMLElement>, versionId:DesignVersionId):void
    {
        event.preventDefault();
        event.stopPropagation();

        controllers.ui.designVersions.selectVersionToCompare(versionId);
    }

    private _onClickVersion(event:React.MouseEvent<HTMLElement>, versionId:DesignVersionId):void
    {
        event.preventDefault();
        event.stopPropagation();

        controllers.ui.designVersions.openVersion(versionId);
    }

    @bind
    private _renderMenu(versionId:DesignVersionId):JSX.Element
    {
        const {ui: {designVersions}} = controllers;
        const state = designVersions.getState();

        const togglerId = 'designVersionMenu' + versionId;

        const isMenuOpened = state.menuVersionId === versionId;

        return (
            <div
                className={cx('menu', {isMenuOpened})}
                id={togglerId}
            >
                <ContextMenu
                    toggleOn={[ToggleOn.CLICK]}
                    togglersIds={[togglerId]}
                    popupAnchor={PopupAnchor.RightTop}
                    sourceAnchor={SourceAnchor.RightBottom}
                    popupClassName={cx('menuPopup')}
                    dataSource={this._menuProvider(versionId)}
                    onShow={() => this._setMenuOpened(versionId)}
                    onHide={() => this._setMenuOpened(null)}
                >
                    <MDIcon
                        className={cx('menuIcon')}
                        name={MDIcons.common.ThreeDotsVert}
                        size={MDIconSize.medium20}
                    />
                </ContextMenu>
            </div>
        );
    }

    @action.bound
    private _setMenuOpened(versionId:DesignVersionId)
    {
        const {ui: {designVersions}} = controllers;
        const state = designVersions.getState();

        state.menuVersionId = versionId;
    }

    private _menuProvider = (versionId:DesignVersionId):(target:ContextMenuTarget) => IContextMenuItem[] =>
    {
        const {feature, ui: {designVersions, dialogs}} = controllers;
        const state = designVersions.getState();

        return (target:ContextMenuTarget):IContextMenuItem[] =>
        {
            const menuItems:IContextMenuItem[] = [];

            const isCanRestore = designVersions.isCanRestore(versionId);

            menuItems.push({
                label: 'Rename',
                handler: () => dialogs.showDialog(
                    Dialogs.NameCurrentVersion,
                    false,
                    {
                        isRename: true,
                        versionId
                    }
                )
            });

            menuItems.push({
                label: 'Restore this version',
                handler: () => designVersions.confirmRestoreVersion(versionId),
                isDisabled: !isCanRestore
            });

            if( feature.canDeleteVersionSnapshots() )
                menuItems.push({
                    label: 'Remove',
                    handler: () =>
                    {
                        const version:DesignVersion = state.versions.find(
                            (version:DesignVersion) => version.id === versionId
                        );

                        const props = {
                            title: 'Remove design version',
                            content: <div>Design version <b>{version.name}</b> will be removed</div>,
                            buttonSet: ConfirmButtonSet.DELETE_CANCEL,
                            intent: MDIntent.Danger,
                            onConfirmed: () =>
                            {
                                designVersions.deleteVersion(versionId);
                            },
                        };

                        dialogs.showDialog(Dialogs.Confirm, false, props);
                    },
                    isDisabled: !isCanRestore
                });

            return menuItems;

        };
    };
}
